// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"ea7499ca6ace9d58b93e","532":"10cf693b0eaba480cbc6","691":"1e66106cafb23d4312d9"}[chunkId] + ".js";
};